// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__5ORQm","details":"styles_details__r_aI5","opacity50":"styles_opacity50__rktay"};